import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map, List } from 'immutable';
import { unflatten } from 'flat';

import Loading from '../Loading';
import { Popup } from 'src/components/Popup/Popup';
import CreateUserForm from '../CreateUserForm';

class CreateEventModal extends React.Component {
    static propTypes = {
        onCreateUserRequest: PropTypes.func,
        roles: ImmutablePropTypes.map,
        id: PropTypes.number,
        active: PropTypes.bool,
        onClose: PropTypes.func,
        onFinish: PropTypes.func
    };

    static defaultProps = {
        active: false
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            active: props.active
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.active) {
            this.setState({
                active: true
            });
        }
    }

    onCreate(data) {
        this.props.onCreateUserRequest(data);
    }

    render() {
        const { onClose, active } = this.props;

        return (
            <Popup
                title="Create user"
                className="create-user-modal"
                priority={ 1000 }
                active={ active }
                onClose={ onClose }
            >
                <CreateUserForm
                    onSubmit={ this.onCreate.bind(this)}
                    roles={ this.props.roles }
                />
            </Popup>
        );
    }
}

export default CreateEventModal;
